import React from 'react';
import { SaveButton, Toolbar } from 'react-admin';

const PanelFormToolbar = ({ hasSuccessfulCsvValidation, hasCsvErrors, isValidating, ...props }) => {

  const isSaveDisabled =
    isValidating ||
    hasCsvErrors ||
    !hasSuccessfulCsvValidation;

  return (
    <Toolbar {...props}>
      <SaveButton disabled={isSaveDisabled} />
    </Toolbar>
  );
};

export default PanelFormToolbar;